import company from './company';

export const categories = [
  { id: "rinsin-blue", label: "RINSIN BLUE", icon: "●" },
  { id: "rinse-blue", label: "RINSE BLUE", icon: "●" },
  { id: "mid-blue", label: "MID BLUE", icon: "●" },
  { id: "dk-grey", label: "DK GREY", icon: "●" },
  { id: "dk-j-black", label: "DK J BLACK", icon: "●" },
  { id: "ink-blue", label: "INK BLUE", icon: "●" },
  { id: "dark-indigo", label: "DARK INDIGO", icon: "●" },
  { id: "resin-blue", label: "RESIN BLUE", icon: "●" },
  { id: "black-selvedge", label: "BLACK SELVEDGE", icon: "●" },
  { id: "blue-selvedge", label: "BLUE SELVEDGE", icon: "●" },
  { id: "dk-blue", label: "DK BLUE", icon: "●" },
  { id: "dk-black", label: "DK BLACK", icon: "●" },
  { id: "light-black", label: "LIGHT BLACK", icon: "●" },
  { id: "light-blue", label: "LIGHT BLUE", icon: "●" },
  { id: "blue-black", label: "BLUE BLACK", icon: "●" },
  { id: "vintage-blue", label: "VINTAGE BLUE", icon: "●" }
];

export const products = [
  {
    id: "rd-101",
    name: "Imperial Indigo Slim Fit Denim",
    category: "men",
    subCategory: "classic-blue",
    categoryLabel: "Men's Classic Slim",
    gender: "Men",
    color: "Rinsin blue",
    fit: "Bootcut fit",
    isNewArrival: true,
    tagline: "Structured 13.5 oz Ringspun Indigo",
    description: "Classic deep indigo denim with precision contrast stitching, subtle whiskering, and engineered ergonomic stretch for optimal mobility.",
    images: [
      "/WhatsApp Image 2026-08-26 at 9.00.32 AM.jpeg",
      "/WhatsApp Image 2026-08-26 at 9.00.33 AM.jpeg"
    ],
    features: ["13.5 oz Premium Indigo", "Ergonomic Stretch Weave", "Brass Rivet Hardware", "Color Fastness Certified"],
    featured: true
  },
  {
    id: "rd-102",
    name: "Midnight Selvage Red-Line Denim",
    category: "dark-selvage",
    subCategory: "men",
    categoryLabel: "Selvage Heritage",
    gender: "Men",
    color: "Blue selvedge",
    fit: "Straight fit",
    isNewArrival: true,
    tagline: "Heavyweight Red-Line Shuttle Loom Edge",
    description: "Unwashed raw midnight denim featuring clean selvage ID edge, oxidized brass rivets, and heavy-duty pocket lining.",
    images: [
      "/denim_category_selvage.png",
      "/WhatsApp Image 2026-08-26 at 9.00.36 AM.jpeg"
    ],
    features: ["14 oz Shuttle Loom Selvage", "Red-Line ID Cuff Edge", "Embossed Leather Patch", "Deep Navy Retention"],
    featured: true
  },
  {
    id: "rd-103",
    name: "Sovereign High-Rise Contour Denim",
    category: "women",
    subCategory: "classic-blue",
    categoryLabel: "Women's Fit",
    gender: "Women",
    color: "Light blue",
    fit: "Ankle",
    isNewArrival: true,
    tagline: "Premium High-Waist Contour Stretch",
    description: "Sculpting high-rise women's denim engineered with 360 flex recovery for flawless silhouette retention and soft hand-feel.",
    images: [
      "/denim_women_fit.png",
      "/WhatsApp Image 2026-08-26 at 9.00.38 AM (1).jpeg"
    ],
    features: ["360° Flex Recovery Stretch", "Ankle Grazer Inseam", "Contour Waistband", "Eco-Enzyme Softener"],
    featured: true
  },
  {
    id: "rd-104",
    name: "Monarch Utility Trucker Jacket",
    category: "jackets",
    subCategory: "men",
    categoryLabel: "Outerwear",
    gender: "Unisex",
    color: "Dark indigo",
    fit: "Relaxed fit",
    isNewArrival: true,
    tagline: "Triple-Needle Reinforced Structural Outerwear",
    description: "Heavyweight denim outerwear engineered for longevity featuring double chest flap pockets, adjustable waist tabs, and copper rivets.",
    images: [
      "/denim_category_jackets.png",
      "/WhatsApp Image 2026-08-26 at 9.00.33 AM.jpeg"
    ],
    features: ["14.5 oz Structured Denim", "Triple-Needle Lap Seams", "Dual Interior Pockets", "Branded Copper Shank Buttons"],
    featured: true
  },
  {
    id: "rd-105",
    name: "Onyx Sulfur Black Tapered Denim",
    category: "black-denim",
    subCategory: "men",
    categoryLabel: "Onyx Black",
    gender: "Men",
    color: "Dk black",
    fit: "Slim tapper",
    isNewArrival: false,
    tagline: "Sulfur Black Dye with Eco-Enzyme Finish",
    description: "Deep sulfur black denim treated with soft eco-enzyme wash to reveal subtle tonal grain and soft hand-feel.",
    images: [
      "/WhatsApp Image 2026-08-26 at 9.00.37 AM.jpeg",
      "/WhatsApp Image 2026-08-26 at 9.00.38 AM (1).jpeg"
    ],
    features: ["12.5 oz Double-Black Weft", "Tonal Topstitching", "Matte Gunmetal Trim", "Anti-Fading Shield"],
    featured: true
  },
  {
    id: "rd-106",
    name: "Artisan Stone-Washed Heritage Jean",
    category: "vintage-washed",
    subCategory: "men",
    categoryLabel: "Artisan Washed",
    gender: "Men",
    color: "Vintage blue",
    fit: "Straight ankle",
    isNewArrival: false,
    tagline: "Hand-Scraped Vintage Micro-Distressing",
    description: "Multi-stage washed denim capturing authentic vintage character through 3D whiskering, hand sanding, and resin treatment.",
    images: [
      "/WhatsApp Image 2026-08-26 at 9.00.38 AM.jpeg",
      "/WhatsApp Image 2026-08-26 at 9.00.40 AM.jpeg"
    ],
    features: ["3D Laser Whiskering", "Pumice Eco-Wash", "Heavy-Duty Pocket Bags", "Reinforced Belt Loops"],
    featured: true
  },
  {
    id: "rd-107",
    name: "Global Executive Dark Slim Fit",
    category: "dark-selvage",
    subCategory: "men",
    categoryLabel: "Dark & Deep Blue",
    gender: "Men",
    color: "Ink blue",
    fit: "Slim fit",
    isNewArrival: false,
    tagline: "Clean Unwashed Finish for Corporate Retail",
    description: "Sleek dark wash denim without distressing, designed for smart-casual corporate and premium urban retail markets.",
    images: [
      "/WhatsApp Image 2026-08-26 at 9.00.36 AM.jpeg",
      "/WhatsApp Image 2026-08-26 at 9.00.32 AM.jpeg"
    ],
    features: ["12 oz Comfort Stretch", "Discreet Tonal Stitching", "Wrinkle Resistant Finish", "High Rub Fastness"],
    featured: false
  },
  {
    id: "rd-108",
    name: "Aero-Light Capsule Summer Denim",
    category: "new-arrivals",
    subCategory: "women",
    categoryLabel: "New Arrivals",
    gender: "Women",
    color: "Mid blue",
    fit: "Skinny fit",
    isNewArrival: true,
    tagline: "Breathable Light-Tone Denim Weave",
    description: "Featherweight summer denim crafted with high-airflow cotton blend for tropical and warm climate retail distribution.",
    images: [
      "/denim_new_arrivals.png",
      "/denim_women_fit.png"
    ],
    features: ["9.5 oz Light Airy Fabric", "Moisture Wicking Cotton Blend", "Soft Sunburst Wash", "Comfort Stretch"],
    featured: true
  }
];

export const generateWhatsAppLink = (productName, buyerType = "International Buyer") => {
  const cleanNumber = company.whatsapp.replace(/[^0-9]/g, '');
  const message = `Hello RAYYAN DENIM Export Team,

I am an ${buyerType} interested in your export collection: "${productName}".

I would like to discuss international export requirements, container volume sourcing, and catalog options.

Please connect me with your export director.

Thank you.`;

  return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
};

export const generateGeneralWhatsAppLink = (buyerType = "International Buyer") => {
  const cleanNumber = company.whatsapp.replace(/[^0-9]/g, '');
  const message = `Hello RAYYAN DENIM Export Team,

I am an ${buyerType} visiting your official global portal.

I am interested in starting a corporate export enquiry regarding your denim distributorship and worldwide export collections.

Please share more information on how we can proceed.

Thank you.`;

  return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
};
